import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextInput } from 'components/Form'
import {
    createApiRecord,
    updateApiRecord,
} from 'services/TransportProviderServicesService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { serviceTypeOptions } from 'utils/options'
injectReducer('transportProviderService', reducer)

const validationSchema = Yup.object().shape({
    // company: Yup.number().required('Please select company'),
    transport_provider: Yup.number().required('Please select Carrier'),
    // carrier_name: Yup.string().required('Carrier Name Required'),
    name: Yup.string().required('Service Name Required'),
    short_code: Yup.string().required('Service Code Required'),
    service_type: Yup.string().nullable().optional(),
    description: Yup.string().nullable().optional(),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userInfo = useSelector((state) => state.auth.user)
    const { transportProviderData } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector(
        (state) => state.transportProviderService.data,
    )

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () =>
        navigate('/transport-service-provider/transport-provider-service')

    const handleSubmit = (values, setSubmitting) => {
        setSubmitting(true)
        if (id) {
            updateApiRecord(id, values)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        } else {
            values.created_by = userInfo.id
            createApiRecord(values)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Transport Provider Service
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full xl:w-1/2 bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Update Transport Provider Service'
                                : 'Add New Transport Provider Service'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                        {/* <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={errors.company && touched.company}
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={e => {
                                                        form.setFieldValue(field.name, e.target.value)
                                                        form.setFieldValue('client', '')
                                                        form.setFieldValue('transport_provider', '')
                                                        form.setFieldValue('service', '')
                                                        dispatch(getTransportProviderData({ company: e.target.value }))
                                                        dispatch(getTransportProviderServiceData({ company: e.target.value }))
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.filter(
                                                        item => item?.client && item?.company?.id.toString() === values?.company
                                                    )}
                                                    label="Client Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={errors.client && touched.client}
                                                    message={errors.client}
                                                    value={values?.client}
                                                    disabled={!values?.company}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field> */}
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Service Provider',
                                                    )}
                                                    label="Carrier"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="name">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Service Name"
                                                    name="name"
                                                    error={
                                                        errors.name &&
                                                        touched.name
                                                    }
                                                    message={errors.name}
                                                    value={values?.name}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="short_code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Service Code"
                                                    name="short_code"
                                                    error={
                                                        errors.short_code &&
                                                        touched.short_code
                                                    }
                                                    message={errors.short_code}
                                                    value={values?.short_code}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="service_type">
                                            {({ field, form }) => (
                                                <Select
                                                    options={serviceTypeOptions}
                                                    label="Service Type"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="service_type"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.service_type &&
                                                        touched.service_type
                                                    }
                                                    message={
                                                        errors.service_type
                                                    }
                                                    value={values?.service_type}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="description">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Description"
                                                    name="description"
                                                    error={
                                                        errors.description &&
                                                        touched.description
                                                    }
                                                    message={errors.description}
                                                    value={values?.description}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
